import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LanguagePickerUiService {
	private readonly openInternal = signal(false);
	private readonly openSubject = new BehaviorSubject(false);

	readonly isOpen = this.openInternal.asReadonly();
	readonly isOpen$ = this.openSubject.asObservable();

	open(): void {
		this.openInternal.set(true);
		this.openSubject.next(true);
	}

	close(): void {
		this.openInternal.set(false);
		this.openSubject.next(false);
	}
}
